import React, { Component } from 'react';
import classNames from 'classnames';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';

const AskSchema = Yup.object().shape({
  phone: Yup.string().required('Required'),
  message: Yup.string()
    .min(2, 'Too Short!')
    .max(300, 'Too Long!')
    .required('Required'),
  email: Yup.string()
    .email('Invalid email')
    .required('Required'),
});

class Ask extends Component {
  constructor(props) {
    super(props);
    this.state = { isSuccess: false, isError: false };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    e.preventDefault();
    this.setState({ isSuccess: false, isError: false });
  }

  render() {
    const { isSuccess, isError } = this.state;

    return (
      <Formik
        initialValues={{ email: '', phone: '', message: '' }}
        validationSchema={AskSchema}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          this.setState({ isSuccess: false, isError: true });
          fetch('https://us-central1-dom-yalta.cloudfunctions.net/question', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(values),
          })
            .then(() => {
              resetForm({ email: '', phone: '', message: '' });
              setSubmitting(false);
              this.setState({ isSuccess: true, isError: false });
            })
            .catch(() => {
              setSubmitting(false);
              this.setState({ isSuccess: false, isError: true });
            });
        }}
      >
        {({
          values, isSubmitting, errors, touched,
        }) => (
          <Form>
            <div className="box-title">Задать вопрос</div>
            <div className="box-content">
              {!isSubmitting && isSuccess && !isError ? (
                <p className="pararaph paragraph-success">
                  Ваш вопрос отправлен. Мы свяжемся с вами в скором времени
                </p>
              ) : null}
              {!isSubmitting && !isSuccess && isError ? (
                <p className="pararaph paragraph-error">Что-то пошло не так, попробуйте позже</p>
              ) : null}
              <div className="form-group">
                <div className="form-control">
                  <div
                    className={classNames('form-element phone', {
                      error: errors.phone && touched.phone,
                    })}
                  >
                    <Field
                      type="tel"
                      name="phone"
                      className="input"
                      placeholder="Телефон"
                      value={values.phone}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group">
                <div className="form-control">
                  <div
                    className={classNames('form-element', {
                      error: errors.email && touched.email,
                    })}
                  >
                    <Field
                      type="tel"
                      name="email"
                      className="input"
                      placeholder="Почта"
                      value={values.email}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group">
                <div className="form-control">
                  <div
                    className={classNames('form-element', {
                      error: errors.message && touched.message,
                    })}
                  >
                    <Field
                      component="textarea"
                      name="message"
                      className="input"
                      cols="30"
                      rows="10"
                      placeholder="Вопрос..."
                      value={values.message}
                    />
                  </div>
                </div>
              </div>
            </div>
            <button type="submit" className="btn" disabled={isSubmitting}>
              Спросить
            </button>
          </Form>
        )}
      </Formik>
    );
  }
}

export default Ask;
